<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model.trim="search.code" @change="Search" placeholder="记录编码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="search.kname" @change="Search" placeholder="模糊搜索名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="search.schema" @change="Search" placeholder="终端编号"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addPage">新建</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
      <el-table-column label="页面名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="终端编号">
        <template v-slot="scope">
          <span>{{ scope.row.schema }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300px">
        <template v-slot="scope">
          <el-button type="danger" size="small" @click="deleteLan(scope.row.code)">删除</el-button>
          <el-button type="primary" size="small" @click="editLan(scope.row)">修改</el-button>
          <router-link style="margin-left: 10px" :to="'/iotmanage/multilanguage/pageelement/' + scope.row.code">
            <el-button type="info" size="small">页面元素</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title+'语言信息'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <!-- <el-form-item label="记录编码" label-width="100px">
          <el-input v-model="form.code" :disabled="edit" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="页面名称" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="终端编号" label-width="100px">
          <el-input v-model="form.schema" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="Validate(addconfirm)">新增</el-button>
          <el-button type="primary" v-if="edit" @click="Validate(editconfirm)">修改</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      title: '',
      search: {
        code: '',
        kname: '',
        schema: '',
        page: 1,
        limit: 10,
      },
      list: [],
      edit: false,
      dialogFormVisible: false,
      form: {
        code: '',
        name: '',
        schema: '',
      },
      rules: {
        name: [{ required: true, message: '请输入页面名称', trigger: 'blur' }]
      },
      total: 0
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Search(){
      this.api.MultiLanguageList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    addPage () {
      this.form = {
        code: '',
        name: '',
        schema: '',
      }
      this.title = '新增'
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.edit = false
      this.dialogFormVisible = true
    },
    editLan (item) {
      this.edit = true
      this.title = '修改'
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.api.MultiLanguageDetail({
        code: item.code
      }).then(res => {
         if (res.data.code == 200) {
          this.dialogFormVisible = true
          this.form = res.data.data
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    deleteLan(item) {
      this.$confirm('是否删除该多语言?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.MultiLanguageDelete({
          code: item
        }).then(res => {
          if (res.data.code == 200) {
            this.Search()
            this.$message.success('删除成功')
            return
          }
          this.$message.error('删除失败'+ res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    addconfirm(){
      this.update()
    },
    update (){
      this.api.MultiLanguageUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.Search()
          this.$message.success(this.title + '成功')
          this.dialogFormVisible = false
          return
        }
        this.$message.error(this.title + '失败' + res.data.msg)
      })
    },
    editconfirm(){
      this.update()
    },
  },
  filters: {},
  mounted () { },
  created () {
    this.Search()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
